export const titleSup = {
  name: 'titleSup',
  inserted: function (el, binding) {
    const str = binding.value.replace('\r\n', '<br/>').replace('\r', '<br/>');
    if (str.includes('**')) {
      const openingTag = '<sup class="supTxt">';
      const endingTag = '</sup>';
      const strArr = str.split('**');
      const output = strArr.reduce((acc, curr, i) => {
        acc += curr;
        if (i < strArr.length - 1) {
          if (i % 2) {
            acc += endingTag;
          } else {
            acc += openingTag;
          }
        }
        return acc;
      }, '');

      el.insertAdjacentHTML('beforeend', output);
    } else {
      el.insertAdjacentHTML('beforeend', str);
    }
  },
};
